<template>
    <div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">

        <div class='position-relative d-flex flex-column h-100'>
            <loading ref="loading"></loading>

            <div class='flex-grow-1-scroll h-100'>
                <div class="errors">
					<template v-for="(error, key) in errors">
						<p :key='"" + key + "-" + mkey' class="alert alert-warning" v-for="(message, mkey) in error">{{message}}</p>
					</template>
				</div>
                <div v-if='true'>
                    <div class="pl-3 pr-3 mt-3">

                        <div class="d-flex flex-column pl-0">
                            <h1 class="h2">{{ titleCase($t('translations.capacity_planning')) }}</h1>
                            <!-- <template v-if='is_network_admin()'>
                                <label class="p-0 col-4">{{ $t('translations.provider')}}</label>
                                <select v-model='provider_id'  class="form-control col-4 mb-2">
                                    <option v-for="provider in sortByValue($root.lookup.providers)" :value="provider.id" :key="provider.id">{{provider.name}}</option>
                                </select>
                            </template> -->
                        </div>
                        <div class="">
                            <table class="table table-bordered table-compact bg-white text-center table-capacity">
                                
                                <tbody>
                                    <tr>
                                        <th class="text-left">{{ capitalise($t('translations.list_size')) }}</th>
                                        <td class="text-right">{{$root.provider.practice_list_size.toLocaleString()}}</td>
                                    </tr>

                                    <tr>
                                        <td colspan='11'>&nbsp;</td>
                                    </tr>

                                    <tr>
                                        <th class="text-left">{{ capitalise($t('translations.demand_per_week')) }}</th>
                                        <th class="text-right">{{ capitalise($t('translations.clinical')) }}</th>
                                        <th class="text-right">{{ capitalise($t('translations.other')) }}</th>
                                        <th class="text-right">{{ capitalise($t('translations.total')) }}</th>
                                    </tr>

                                    <tr>
                                        <td class="text-right">{{ capitalise($t('translations.typical')) }}</td>
                                        <td class="text-right">{{ item.typical_clinical }}%</td>
                                        <td class="text-right">{{ item.typical_other }}%</td>
                                        <td class="text-right">&nbsp;</td>
                                    </tr>

                                    <tr>
                                        <td class="text-right">{{ capitalise($t('translations.actual')) }}</td>
                                        <td class="text-right editable text-light fit"><input type="number" min="0" max="100" size='3' step='0.1' class="text-right" v-model="item.actual_clinical"> %</td>
                                        <td class="text-right editable text-light fit"><input type="number" min="0" max="100" size='3' step='0.1' class="text-right" v-model="item.actual_other"> %</td>
                                        <td class="text-right">{{ badNumber((parseFloat(item.actual_clinical) + parseFloat(item.actual_other)).toFixed(1)) }}%</td>
                                    </tr>

                                    <tr>
                                        <td colspan='11'>&nbsp;</td>
                                    </tr>

                                    <tr>
                                        <td colspan='3'>&nbsp;</td>
                                        <th class="text-right">{{ capitalise($t('translations.capacity_per_session')) }}</th>
                                        <td class="text-right editable text-light fit"><input 
                                            type="number" 
                                            min="0"
                                            size="3"
                                            class="text-right" 
                                            v-model="item.capacity_per_session"></td>
                                    </tr>

                                    <tr>
                                        <td colspan='11'>&nbsp;</td>
                                    </tr>
                                    
                                    <tr>
                                        <th class="text-left">{{ capitalise($t('translations.demand_per_day_as_percent_of_week')) }}</th>
                                        <th class="text-right">{{ capitalise($t('translations.typical')) }}</th>
                                        <th class="text-right">{{ capitalise($t('translations.actual')) }}</th>
                                        <th class="text-center">{{ capitalise($t('translations.predicted_demand')) }}</th>
                                        <th class="text-right">{{ capitalise($t('translations.sessions')) }}</th>
                                    </tr>
                                    <tr :key='day_of_week' v-for="(day, day_of_week) in $root.lookup.dayNames">
                                        <td class="text-right">{{ capitalise(day) }}</td>
                                        <td class="text-right">{{ item.typical_demand[day_of_week] }}%</td>
                                        <td class="text-right editable text-light fit"><input v-if="is_superuser() || is_admin()" 
                                            type="number" 
                                            min="0"
                                            max="100"
                                            size="3"
                                            class="text-right" 
                                            v-model='item.actual_demand[day_of_week]'> %</td>
                                        <td class="text-center">
                                            <!-- <input v-if="is_superuser() || is_admin()" type="number" min="0" 
                                            class="form-control" 
                                            v-model='provider.demand.find(obj => {return obj.day_of_week == day_of_week}).demand'> -->
                                            <strong>{{ badNumber(Math.round(getPredictedDemand(day_of_week))) }}</strong>
                                            </td>
                                        <td class="text-right">{{ badNumber((getPredictedDemand(day_of_week) / item.capacity_per_session).toFixed(1)) }}</td>
                                        
                                    </tr>
                                    <tr>
                                        <th class="text-right">{{ capitalise($t('translations.total')) }}</th>
                                        <th class="text-right">100%</th>
                                        <th class="text-right">{{ badNumber(total_actual_demand) }}%</th>
                                        <th class="text-center">
                                            {{ badNumber(Math.round(getTotalPredictedDemand())) }}
                                        </th>
                                        <th class="text-right">{{ badNumber((getTotalPredictedDemand() / item.capacity_per_session).toFixed(1)) }}</th>
                                        
                                    </tr>

                                    
                                    
                                </tbody>
                            </table>


                        </div>

                    </div>
                </div>

            </div><!-- flex-grow-1-scroll h-100 -->
            <footer class="container-footer">
                <div v-if='is_superuser() || is_admin()' class="d-flex flex-row-reverse">
					<button class="btn btn-success btn-round" :disabled='!valid' v-on:click.prevent='save' role="button">{{ capitalise($t('translations.save_to_dashboard')) }}</button>
				</div>
            </footer>
        </div>

    </div><!--ref:container-->


</template>

<script>
export default {
    props: [
        'id'
    ],
    data: function(){
        return {
            errors: [],

            item: {
                typical_clinical: 6.5,
                typical_other: 1,
                actual_clinical: this.$root.provider.dpw_clinical ? this.$root.provider.dpw_clinical : 6.5,
                actual_other: this.$root.provider.dpw_other ? this.$root.provider.dpw_other : 1,
                capacity_per_session: this.$root.provider.capacity_per_session ? this.$root.provider.capacity_per_session : 25,
                typical_demand: {
                    1: 28,
                    2: 20,
                    3: 18,
                    4: 18,
                    5: 16,
                    6: 0,
                    7: 0,
                },
                actual_demand: {
                    1: 28,
                    2: 20,
                    3: 18,
                    4: 18,
                    5: 16,
                    6: 0,
                    7: 0,
                }
            }
        };
    },
    watch: {

    },
    computed: {
        valid: {
            get: function() {
                var valid = true;
                Object.keys(this.$root.lookup.dayNames).forEach((day_of_week) => {
                    if(!isFinite(this.getPredictedDemand(day_of_week))) {
                        valid = false;
                    }
                });
                return valid;
            }
        },
        
        total_actual_demand: {
            get: function() {
                var total = 0;
                Object.keys(this.item.actual_demand).forEach(day_of_week => {
                    total += parseFloat(this.item.actual_demand[day_of_week]);
                })
                return parseFloat(total);
            }
        }
        
    },
    mounted() {
        this.initData();
    },
    beforeDestroy() {
        this.deinitData();
    },
    beforeRouteUpdate (to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    beforeRouteLeave(to, from, next) {
        this.checkRouteChange(to, from, next);
    },
    methods: {
        checkRouteChange(to, from, next) {
            this.checkUnsaved(this.originalData, this.item, to, from, next);
        },
        badNumber(number) {
            if(!isFinite(number)) {
                return "--";
            }
            return number;
        },
        getPredictedDemand(day_of_week) {
            return Math.round(
                this.$root.provider.practice_list_size 
                * ((parseFloat(this.item.actual_clinical) + parseFloat(this.item.actual_other)) / 100) 
                * (this.item.actual_demand[day_of_week] / 100))
        },
        getTotalPredictedDemand() {
            var total = 0;
            Object.keys(this.item.actual_demand).forEach(day_of_week => {
                total += 
                this.$root.provider.practice_list_size 
                * ((parseFloat(this.item.actual_clinical) + parseFloat(this.item.actual_other)) / 100) 
                * (this.item.actual_demand[day_of_week] / 100);
            });
            return total;
        },
        
        initData() {
            this.getData();
        },

        deinitData() {
            
        },
        
        getData(showLoading) {
            Object.keys(this.$root.lookup.dayNames).forEach((day_of_week) => {
                var demand = this.$root.provider.demand.find(obj => {return obj.day_of_week == day_of_week});
                this.item.actual_demand[day_of_week] = demand.planning_demand_percent ? demand.planning_demand_percent : this.item.typical_demand[day_of_week];
            });
            this.originalData = JSON.parse(JSON.stringify(this.item));
        },

        save() {
            var data = {
                demand: [],
                dpw_clinical: this.item.actual_clinical,
                dpw_other: this.item.actual_other,
                capacity_per_session: this.item.capacity_per_session,
            };
			this.errors = [];
            this.setLoading(true);
            Object.keys(this.$root.lookup.dayNames).forEach((day_of_week) => {
                data.demand.push({
                    day_of_week: day_of_week,
                    demand: this.getPredictedDemand(day_of_week),
                    planning_demand_percent: this.item.actual_demand[day_of_week],
                });
            });
            
			axios
				.put("/api/v1/providers/demand", data)
				.then(res => {
                    this.setLoading(false);
                    this.originalData = JSON.parse(JSON.stringify(this.item));
					this.addNotification({
						type: "success",
						content: "Demand updated successfully"
					});
				})
			.catch(error => {
				this.setLoading(false);
				this.handleError(error, "update");
			});
		},
    }
}
</script>
